import React from 'react';
import { User, Phone, EnvelopeSimple, MapPin, UsersThree } from '@phosphor-icons/react';

const Tel = ({ n }) => (n ? <a className="text-primary underline" href={`tel:${n}`}>{n}</a> : '—');

const Item = ({ icon: Icon, label, children, testId }) => (
  <div className="flex items-start gap-2 py-1.5" data-testid={testId}>
    <Icon size={15} className="text-primary mt-0.5 shrink-0" weight="duotone" />
    <div className="min-w-0">
      <div className="text-[11px] uppercase tracking-wider text-foreground/50">{label}</div>
      <div className="text-sm text-foreground/90 break-words">{children}</div>
    </div>
  </div>
);

export const ClientContactCard = ({ c, testId = 'client-contact-card' }) => {
  const address = [c.street, [c.cap, c.comune].filter(Boolean).join(' '), c.province].filter(Boolean).join(', ');
  const patientPhone = c.is_patient ? (c.patient_phone || c.contact_phone) : c.patient_phone;
  return (
    <div className="p-3 rounded-xl bg-primary/5 border border-primary/20" data-testid={testId}>
      <div className="text-sm font-semibold mb-1">Dati del cliente</div>
      <div className="grid sm:grid-cols-2 gap-x-6">
        <Item icon={User} label="Richiedente" testId="contact-requester">
          {c.requester_name || '—'}
          {c.is_patient !== undefined && c.is_patient !== null && <span className={`ml-2 text-[10px] px-2 py-0.5 rounded-full ${c.is_patient ? 'bg-emerald-100 text-emerald-800' : 'bg-sky-100 text-sky-800'}`} data-testid="contact-is-patient">
            {c.is_patient ? 'È il paziente' : 'Non è il paziente'}
          </span>}
        </Item>
        <Item icon={User} label="Paziente" testId="contact-patient">{c.patient_name || c.requester_name || '—'}</Item>
        <Item icon={Phone} label="Telefono richiedente" testId="contact-phone"><Tel n={c.contact_phone} /></Item>
        <Item icon={EnvelopeSimple} label="Email richiedente" testId="contact-email">
          {c.contact_email ? <a className="text-primary underline" href={`mailto:${c.contact_email}`}>{c.contact_email}</a> : '—'}
        </Item>
        <Item icon={Phone} label="Telefono paziente" testId="contact-patient-phone"><Tel n={patientPhone} /></Item>
        <Item icon={UsersThree} label="Familiare di riferimento" testId="contact-family">
          {c.family_member_name || '—'}{c.family_phone && <> · <Tel n={c.family_phone} /></>}
        </Item>
        <div className="sm:col-span-2">
          <Item icon={MapPin} label="Indirizzo della prestazione" testId="contact-address">
            {address ? (
              <a className="text-primary underline" target="_blank" rel="noreferrer"
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`}>{address}</a>
            ) : '—'}
          </Item>
        </div>
      </div>
    </div>
  );
};

export default ClientContactCard;
